/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './progress-indicator.scss';
import classNames from 'classnames';
import CloseIcon from 'hellospa/icons/close';

type Props = {
  progress: number, // 0 ≤ n ≤ 1.
  showCancelButton?: boolean,
  showLoadingMessage?: boolean,
  customLoadingMessage?: string,
  onCancel?: Function,
  className?: string
};

function ProgressIndicatorUI({
  progress = 0,
  showCancelButton = true,
  showLoadingMessage = true,
  onCancel,
  customLoadingMessage,
  className,
}: Props, ref: React.Ref<HTMLDivElement>) {
  const fillPercentage = React.useMemo(() => {
    const clippedProgress = Math.min(Math.max(0, progress), 1);

    return `${clippedProgress * 100}%`;
  }, [progress]);

  const loadingMessage = React.useMemo(() => {
    return customLoadingMessage || (
      <FormattedMessage
        id=""
        description="Loading text"
        defaultMessage="Loading…" />
    );
  }, [customLoadingMessage]);

  const handleCancel = React.useCallback(() => {
    if (onCancel) {
      onCancel();
    }
  }, [onCancel]);

  return (
    <div className={classNames(styles.progressIndicator, className)} ref={ref}>
      <div className={styles.barContainer}>
        <div className={styles.bar}>
          <div className={styles.fill} style={{ width: fillPercentage }} />
        </div>
        {showCancelButton && (
          <CloseIcon
            className={styles.cancelButton}
            onClick={handleCancel} />
        )}
      </div>
      {showLoadingMessage && (
        <p>{loadingMessage}</p>
      )}
    </div>
  );
}

const ProgressIndicator = React.forwardRef(ProgressIndicatorUI);
export default ProgressIndicator;
